function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { set } from '@ember/object';
import Service from '@ember/service';
import { setUserData } from '@square/dashboard-utilities/utils/window';

// Add known current user values to the Data type so it can be type checked

export default class CurrentUserData extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "data", {});
  }
  setup(incomingData) {
    set(this, 'data', incomingData);
    Object.freeze(this.data);
    setUserData(incomingData);
  }
}

// This is how TypeScript knows how to look up the service.
/** @hidden */